import { type ChangeEvent } from "react";

import { type CheckboxProps } from "ui/checkbox/checkbox.types";

type UseCheckboxProps = Pick<CheckboxProps, "label" | "onChange">;

export const useCheckbox = ({ label, onChange }: UseCheckboxProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event.target.checked);
  };

  return {
    hasLabel: label !== undefined,
    handleChange,
  };
};
